import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OrderDeliveryType} from "../../model/lib/enums/OrderDeliveryType";
import {OrderChangeOptions} from "../../pages/daymenu-detail/daymenu-detail";
import {Shift} from "../../model/lib/interfaces/Shift";
import {Order} from "../../model/lib/interfaces/Order";
import {OrderStatus} from "../../model/lib/enums/OrderStatus";
import {MenuOption} from "../../utils/menu-helper";
import {ShiftHelper} from "../../utils/shift-helper";

/**
 * Generated class for the OrderCardComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: "order-card",
  templateUrl: "order-card.html"
})
export class OrderCardComponent implements OnInit {
  protected shiftDeliveryTypes: OrderDeliveryType[] = [];

  @Input() shift: Shift;
  @Input() date: string;
  @Input() orderChangeOptions: OrderChangeOptions;
  @Input() veggieDisable: boolean;
  @Input() starterString: string;
  @Input() menuString: string;
  @Input() desertString: string;
  @Input() order: Order;
  @Input() hideDeliveryType = false;
  @Input() hideVeggie = false;
  @Input() menuOptions: MenuOption[] = [];

  @Output() orderChange: EventEmitter<OrderChangeOptions> = new EventEmitter();
  @Output() orderCancel: EventEmitter<void> = new EventEmitter();

  protected disabled: boolean;

  ngOnInit(): void {
    this.updateFromOptions();
  }

  protected veggieChanged(): void {
    this.orderChange.emit(this.orderChangeOptions);
  }

  protected deliveryTypeChanged(): void {
    this.orderChange.emit(this.orderChangeOptions);
  }

  protected menuChanged(): void {
    this.orderChange.emit(this.orderChangeOptions);
  }

  protected isDefaultShift(): boolean {
    return ShiftHelper.isDefaultShift(this.shift);
  }

  protected hasMenuChoice(): boolean {
    return !!this.menuOptions && this.menuOptions.length > 1;
  }

  private updateFromOptions() {
    if (!this.orderChangeOptions) return;

    if (this.shift.name !== 'Abend') {
      this.shiftDeliveryTypes.push(OrderDeliveryType.ON_SITE);
      this.shiftDeliveryTypes.push(OrderDeliveryType.TAKEAWAY);
    }

    this.shiftDeliveryTypes.push(OrderDeliveryType.DELIVERY);
    this.disabled = this.isOrderConsumed(this.order);
  }

  getDeliveryTypeLabel(type: OrderDeliveryType): string {
    switch (type) {
      case OrderDeliveryType.ON_SITE:
        return 'CANTEEN';
      case OrderDeliveryType.TAKEAWAY:
        return 'TAKEAWAY';
      case OrderDeliveryType.DELIVERY:
        return 'DELIVER';
      default:
        return type;
    }
  }

  protected cancelOrder(): void {
    this.orderCancel.emit();
  }

  protected isOrderPending(): boolean {
    if (!this.order || !this.order.status || !this.order.id) return false;

    return this.order.status === OrderStatus.PENDING;
  }

  private isOrderConsumed(order: Order): boolean {
    return order.status === OrderStatus.FINISHED;
  }
}



// WEBPACK FOOTER //
// ./src/components/order-card/order-card.ts